export const SEARCH_DISPATCHED = "SEARCH_DISPATCHED";
export const SEARCH_RECEIVED = "SEARCH_RECEIVED";
export const SEARCH_FAILED = "SEARCH_FAILED";
export const SELECT_SEARCH_VALUE = "SELECT_SEARCH_VALUE";
export const SEARCH_CANCELLED = "SEARCH_CANCELLED";
